<ng-container>
  <div class="image-picker">
    @if (state === 'empty') {
      <div>
        <button mat-raised-button type="button" (click)="openFileBrowser()" class="imageButton">
          <mat-icon>add_a_photo</mat-icon> Kies een bestand
        </button>
        @if (state === 'empty') {
          <input type="file" (change)="fileChanged($event)" accept="image/*" #fileInput
            style="display: none" />
        }
      </div>
    }

    @if (state === 'loading') {
      <app-spinner></app-spinner>
    }

    @if (state !== 'existingImage') {
      <image-cropper [imageChangedEvent]="fileChangedEvent" [maintainAspectRatio]="maintainRatio"
        [aspectRatio]="aspectRatio" [resizeToWidth]="resizeWidth" [imageQuality]="100" format="jpeg"
        (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()"
        (loadImageFailed)="loadImageFailed()">
      </image-cropper>
    }

    @if (state === 'existingImage' && currentImage) {
      <img class="existing-image" [src]="currentImage.imageUrl"
        alt="Huidig plaatje" />
    }

    @if (state === 'cropper' || state === 'existingImage') {
      <div class="tools">
        <button mat-button type="button" color="primary" (click)="clear()">
          <mat-icon>clear</mat-icon> Verwijderen
        </button>
      </div>
    }
  </div>
</ng-container>